export default "__VITE_ASSET__BYrNh9wI__$_?src__"